/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DownloadWorkspaceArchiveRequest = {
  sessionId: string;
  sessionToken?: string | null | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  workspaceArchiveRequest: components.WorkspaceArchiveRequest;
};

/** @internal */
export const DownloadWorkspaceArchiveRequest$inboundSchema: z.ZodType<
  DownloadWorkspaceArchiveRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  session_token: z.nullable(z.string()).optional(),
  "X-On-Behalf-Of": z.string().optional(),
  WorkspaceArchiveRequest: components.WorkspaceArchiveRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "session_token": "sessionToken",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "WorkspaceArchiveRequest": "workspaceArchiveRequest",
  });
});
/** @internal */
export type DownloadWorkspaceArchiveRequest$Outbound = {
  session_id: string;
  session_token?: string | null | undefined;
  "X-On-Behalf-Of"?: string | undefined;
  WorkspaceArchiveRequest: components.WorkspaceArchiveRequest$Outbound;
};

/** @internal */
export const DownloadWorkspaceArchiveRequest$outboundSchema: z.ZodType<
  DownloadWorkspaceArchiveRequest$Outbound,
  z.ZodTypeDef,
  DownloadWorkspaceArchiveRequest
> = z.object({
  sessionId: z.string(),
  sessionToken: z.nullable(z.string()).optional(),
  xOnBehalfOf: z.string().optional(),
  workspaceArchiveRequest: components.WorkspaceArchiveRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    sessionToken: "session_token",
    xOnBehalfOf: "X-On-Behalf-Of",
    workspaceArchiveRequest: "WorkspaceArchiveRequest",
  });
});

export function downloadWorkspaceArchiveRequestToJSON(
  downloadWorkspaceArchiveRequest: DownloadWorkspaceArchiveRequest,
): string {
  return JSON.stringify(
    DownloadWorkspaceArchiveRequest$outboundSchema.parse(
      downloadWorkspaceArchiveRequest,
    ),
  );
}
export function downloadWorkspaceArchiveRequestFromJSON(
  jsonString: string,
): SafeParseResult<DownloadWorkspaceArchiveRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DownloadWorkspaceArchiveRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DownloadWorkspaceArchiveRequest' from JSON`,
  );
}
